const emptylist = {
  headline: 'No Results found',
  message: 'The filters you selected unfortunately yield no results. ',
  cta: 'Reset filters'
}

export default emptylist
